export class UploadLead {
  id: string | null = null;
  lng: number | null = null;
  lat: number | null = null;
}
